<div class="login-wrapper">
  <!-- Panel izquierdo: Branding (solo desktop) -->
  <div class="login-branding">
    <div class="branding-content">
      <!-- Logo icon -->
      <div class="branding-logo-container">
        <img src="assets/img/LogoAW2025.png" alt="Aguacate Wallet" class="branding-icon">
      </div>
      <!-- Texto marca -->
      <h1 class="branding-title">Aguacate<span class="branding-title-light">Wallet</span></h1>
      <p class="branding-subtitle">Profesionales en remesas</p>
      <!-- Decorativo -->
      <div class="branding-features">
        <div class="branding-feature-item">
          <div class="feature-icon-box">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: white;">speed</mat-icon>
          </div>
          <span>Transferencias rapidas y seguras</span>
        </div>
        <div class="branding-feature-item">
          <div class="feature-icon-box">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: white;">verified_user</mat-icon>
          </div>
          <span>Plataforma confiable y regulada</span>
        </div>
        <div class="branding-feature-item">
          <div class="feature-icon-box">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: white;">support_agent</mat-icon>
          </div>
          <span>Soporte personalizado 24/7</span>
        </div>
      </div>
    </div>
    <!-- Circulos decorativos -->
    <div class="branding-circle branding-circle-1"></div>
    <div class="branding-circle branding-circle-2"></div>
    <div class="branding-circle branding-circle-3"></div>
  </div>

  <!-- Panel derecho: Formulario -->
  <div class="login-form-panel">
    <div class="login-form-container">
      <!-- Logo mobile -->
      <div class="login-mobile-logo">
        <img src="assets/img/LogoAW2025.png" alt="Aguacate Wallet" style="width: 48px; height: 48px; object-fit: contain;">
      </div>

      <!-- Logo principal -->
      <div class="login-logo">
        <img src="assets/img/logoAguacateWallet2025.png" alt="Aguacate Wallet"
          style="max-width: 220px; height: auto;">
      </div>

      <!-- Instalar la app. Va acá, pegada al logo, para que se vea sin
           scrollear: al final del formulario quedaba debajo del fold en el
           celular, que es justo donde instalar tiene sentido. Se esconde sola
           si ya está instalada o si el navegador no permite instalar. -->
      <app-install-app-button></app-install-app-button>

      <!-- Titulo -->
      <h2 style="font-size: 1.4rem; font-weight: 800; color: #1e5a3f; margin: 0 0 4px 0; text-align: center;">
        Iniciar sesion
      </h2>
      <p style="font-size: 0.85rem; color: #6b7280; margin: 0 0 24px 0; text-align: center;">
        Ingresa tus credenciales para acceder
      </p>

      <!-- Formulario -->
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm)" style="width: 100%;">

        <!-- Email -->
        <div style="margin-bottom: 16px;">
          <label style="display: block; font-size: 0.8rem; font-weight: 600; color: #374151; margin-bottom: 6px;">
            Correo electronico
          </label>
          <div class="login-input-wrapper" [class.login-input-error]="loginForm.get('email')?.invalid && (loginForm.get('email')?.dirty || loginForm.get('email')?.touched)">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #9ca3af; flex-shrink: 0;">email</mat-icon>
            <input
              type="email"
              name="email"
              id="email"
              formControlName="email"
              (keydown.space)="$event.preventDefault()"
              (paste)="handlePaste($event)"
              autocomplete="on"
              placeholder="nombre@empresa.com"
              style="flex: 1; border: none; outline: none; background: transparent; font-size: 0.88rem; color: #111827; padding: 0;">
          </div>
          <div *ngIf="loginForm.get('email')?.invalid && (loginForm.get('email')?.dirty || loginForm.get('email')?.touched)"
            style="margin-top: 4px;">
            <span *ngIf="loginForm.get('email')?.hasError('required')"
              style="font-size: 0.75rem; color: #dc2626; font-weight: 500;">
              Ingresa el email
            </span>
          </div>
          <div *ngIf="unregisteredMail" style="margin-top: 6px;">
            <div style="display: flex; align-items: flex-start; gap: 6px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 8px 12px;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0; margin-top: 1px;">error_outline</mat-icon>
              <span style="font-size: 0.78rem; color: #991b1b; line-height: 1.4;">
                Este correo no tiene una cuenta vinculada.
                <a [routerLink]="['/auth/dinamic-signup']"
                  style="color: #1C593D; font-weight: 600; text-decoration: underline; cursor: pointer;">
                  Registrate aqui
                </a>
              </span>
            </div>
          </div>
        </div>

        <!-- Password -->
        <div style="margin-bottom: 20px;">
          <label style="display: block; font-size: 0.8rem; font-weight: 600; color: #374151; margin-bottom: 6px;">
            Contraseña
          </label>
          <div class="login-input-wrapper" [class.login-input-error]="loginForm.get('password')?.invalid && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #9ca3af; flex-shrink: 0;">lock</mat-icon>
            <input
              [type]="showPassword ? 'text' : 'password'"
              name="password"
              id="password"
              formControlName="password"
              autocomplete="on"
              placeholder="Ingresa tu contraseña"
              style="flex: 1; border: none; outline: none; background: transparent; font-size: 0.88rem; color: #111827; padding: 0;">
            <button type="button" (click)="showPassword = !showPassword"
              style="background: none; border: none; cursor: pointer; padding: 0; display: flex; align-items: center;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #9ca3af;">
                {{ showPassword ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </button>
          </div>
          <div *ngIf="loginForm.get('password')?.invalid && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)"
            style="margin-top: 4px;">
            <span *ngIf="loginForm.get('password')?.hasError('required')"
              style="font-size: 0.75rem; color: #dc2626; font-weight: 500;">
              Ingresa la contraseña
            </span>
          </div>
        </div>

        <!-- Forgot password link -->
        <div style="display: flex; justify-content: flex-end; margin-bottom: 20px;">
          <a [routerLink]="['/auth/request-password-reset']"
            style="font-size: 0.8rem; font-weight: 600; color: #1C593D; text-decoration: none; cursor: pointer;"
            onmouseover="this.style.color='#059669'" onmouseout="this.style.color='#1C593D'">
            Olvidaste tu contraseña?
          </a>
        </div>

        <!-- Boton submit -->
        <button type="submit"
          [disabled]="loginForm.invalid"
          [style.opacity]="loginForm.invalid ? '0.5' : '1'"
          [style.cursor]="loginForm.invalid ? 'not-allowed' : 'pointer'"
          style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 12px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s ease; letter-spacing: 0.3px;"
          onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="if(!this.disabled)this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">login</mat-icon>
          Iniciar sesion
        </button>

        <!-- Error credenciales -->
        <div *ngIf="loginError && !unregisteredMail" style="margin-top: 12px;">
          <div style="display: flex; align-items: center; gap: 8px; justify-content: center; background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; padding: 10px 16px;">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #dc2626;">error</mat-icon>
            <span style="font-size: 0.82rem; font-weight: 600; color: #991b1b;">Credenciales incorrectas</span>
          </div>
        </div>

        <!-- Terminos -->
        <p style="text-align: center; margin-top: 16px; font-size: 0.75rem; color: #9ca3af; line-height: 1.5;">
          Al continuar, aceptas nuestros
          <a href="https://landing.aguacatewallet.com/uploads/TerminosCondiciones.pdf"
            rel="noreferrer" target="_blank"
            style="color: #1C593D; font-weight: 600; text-decoration: underline;">
            Terminos y Condiciones
          </a>
        </p>
      </form>

      <!-- Separador -->
      <div style="display: flex; align-items: center; gap: 12px; margin: 20px 0;">
        <div style="flex: 1; height: 1px; background: #e5e7eb;"></div>
        <span style="font-size: 0.75rem; color: #9ca3af; font-weight: 500;">o</span>
        <div style="flex: 1; height: 1px; background: #e5e7eb;"></div>
      </div>

      <!-- Registrate -->
      <button type="button" [routerLink]="['/auth/dinamic-signup']"
        style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 11px 24px; background: white; color: #1C593D; border: 2px solid #1C593D; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">person_add</mat-icon>
        Crear una cuenta
      </button>
    </div>
  </div>
</div>
